var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { GET_ZONE_MAPPING_REQUEST, getZoneMappingFailure, getZoneMappingSuccess } from "@/redux/actions";
import APIIN from "@/utils/APIIN";
import { call, put, takeLatest } from "redux-saga/effects";
export const onGetZoneMappingFile = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            APIIN.downloadLabel(`rms/admin/zone/file?tenantId=${action.payload.tenantId}&carrier=${action.payload.carrier}`)
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* GetZoneMappingFileWorker(action) {
    try {
        const data = yield call(onGetZoneMappingFile, action);
        yield put(getZoneMappingSuccess(data));
    }
    catch (error) {
        if (error && (error === null || error === void 0 ? void 0 : error.message)) {
            yield put(getZoneMappingFailure(error === null || error === void 0 ? void 0 : error.message));
        }
        else {
            yield put(getZoneMappingFailure(error));
        }
    }
}
export function* watchGetZoneMappingFileData() {
    yield takeLatest(GET_ZONE_MAPPING_REQUEST, GetZoneMappingFileWorker);
}
